var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 30.25V32H0.25V30.25L3.75 26.75V16.25C3.75 10.825 7.3025 6.0475 12.5 4.5075V4C12.5 3.07174 12.8687 2.1815 13.5251 1.52513C14.1815 0.868749 15.0717 0.5 16 0.5C16.9283 0.5 17.8185 0.868749 18.4749 1.52513C19.1313 2.1815 19.5 3.07174 19.5 4V4.5075C24.6975 6.0475 28.25 10.825 28.25 16.25V26.75L31.75 30.25ZM19.5 33.75C19.5 34.6783 19.1313 35.5685 18.4749 36.2249C17.8185 36.8812 16.9283 37.25 16 37.25C15.0717 37.25 14.1815 36.8812 13.5251 36.2249C12.8687 35.5685 12.5 34.6783 12.5 33.75",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifBell);
export default __webpack_public_path__ + "static/media/notif-bell.534d1e68197aa1d01bf710f5990a3234.svg";
export { ForwardRef as ReactComponent };